// tslint:disable: max-line-length triple-equals
import React, { useEffect, useRef, useState } from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import ControlSelect from 'lqa-ui/lib/Components/ControlSelect';
import './styles.scss';
import { setItem } from '../../utils/localStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  deleteSelfAssessmentAttachment,
  editSelfAssessment,
  editSelfAssessmentWithParent,
  getSelfAssessmentAttachmentForStandard,
  getSelfAssessmentAttachments,
  getSelfAssessmentAttachmentsListOfStandards,
  handleSubmitSelfAssessment,
  uploadSelfAssessmentAttachment,
} from './apiCaller';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent/index';
import { escape, isArray, round, unescape } from 'lodash';
import uuid, { v4 } from 'uuid';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import '../../style/main.scss';
import { OverlayAudio } from '../../components/commons/AudioPlayer/OverlayAudio';
import { getAssessmentPercentageCompleted } from './percentCalulation';
import ControlTextarea from 'lqa-ui/lib/Components/ControlTextarea';
import { getLabel } from '../../enums/labels/PerformanceClassification';
import { isUnauthorized } from '../../utils/common';
import { Body4, Body5, Headline3 } from '../../app/common/typography';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';
import { Modal } from '../../app/common/sharedComponents/Modal';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import { useTranslation } from 'react-i18next';
import {
  ModalHeader,
  ModalContent,
} from '../../app/common/sharedStyledComponents/Modal.styled';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import {
  AssessmentStandarContainer,
  ContentArea,
  TextAreaLabel,
  SubTabContainer,
  DatePickerContainer,
} from './EditSelfAssessment.styled';
import { ScoreContainer } from './EditSelfAssessment.styled';
import { Score } from './Score';
import { IAttachment } from '../../app/@types/myAudit';
import { sentryReport } from '../../helpers/sentry';
import { Cropper } from '../../app/common/sharedComponents/Cropper';
import { GridContainer } from '../../app/common/sharedComponents/Grid/styled.grid';
import { Grid } from '../../app/common/sharedComponents/Grid';
import { ButtonMediaUploadWrapper } from '../../app/myAudit/components/ContentTab/styled.contentTab';
import { ButtonMediaUpload } from '../../app/myAudit/components/ButtonMediaUpload';
import { ImageInputContainer } from '../../style/styled.selfAssessment';
import { SelfAssessmentQuestionCard } from '../../app/selfAssessment/components/SelfAssessmentQuestionCard';
import { HeaderContainer } from '../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { DatePickerDateTime } from '../../app/common/sharedComponents/DatePickerDateTime';
import { DatePickerDateRange } from '../../app/common/sharedComponents/DatePickerDateRange';
import { DatePickerDate } from '../../app/common/sharedComponents/DatePickerDate';
import { DatePickerWrapper } from '../../app/common/sharedStyledComponents/Datepicker.styled';
import { ISelectedOption } from '../../app/@types/searchBox';
import { SearchBoxTaggedUsers } from '../../app/myAudit/components/SearchBoxTaggedUsers';
import { Nullable } from '../../app/@types/genericTypes';
import { StandardAttachment } from './Attachments/StandardAttachment';

/* tslint:disable:object-literal-key-quotes */
const roomNumberOrOutlet = {
  Housekeeping: 'Room Number/Name',
  'Food And Beverage': 'Outlet Name',
};

const EditSelfAssessment = () => {
  const navigate = useNavigate();
  const loc: any = useLocation();
  const { t } = useTranslation();
  const { assessmentId, parentId, categoryId, assess, template } = loc.state;
  const [toggleTab, settoggleTab] = useState([true]);
  const [toggleSubTab, settoggleSubTab] = useState([true]);
  const [subCat, setSubCat] = useState<any>(undefined);
  const [categoryIndex, setCategoryIndex] = useState(1);
  const [selfAssessment, setSelfAssessment] = useState<any>(undefined);
  const [audioOverlayOpened, setAudioOverlayOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(categoryId);
  const [selectedUrl, setSelectedUrl] = useState<
    {
      url: string;
      name?: string;
      notes?: string;
      id?: number;
    }[]
  >([]);
  const [attachments, setAttachments] = useState<IAttachment[]>([]);
  const [attachmentLoader, setAttachmentLoader] = useState<boolean>(false);

  const [showMet, setShowMet] = useState({
    met: false,
    notmet: false,
  });
  const [selectedCategory, setSelectedCategory] = useState<any>(undefined);
  const [isAttachmentUpdated, setIsAttachmentUpdated] = useState(false);
  const [selfAssessmentComment, setSelfAssessmentComment] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [assessed, setAssessed] = React.useState<any>([]);
  const [standardsAttachmentsIds, setStandardsAttachmentsIds] = useState<any>(
    []
  );
  const [dateTime, setDateTime] = useState<any>(undefined);
  const [shouldShowDate, setShouldShowDate] = useState(false);
  const [hasDate, setHasDate] = useState<boolean>(false);
  const [hasDateTime, setHasDateTime] = useState<boolean>(false);
  const [hasDateRange, setHasDateRange] = useState<boolean>(false);
  const [hasSecondaryDateRange, setHasSecondaryDateRange] = useState<boolean>(
    false
  );
  const [dateValue, setDateValue] = useState<any>(undefined);
  const [startDate, setStartDate] = useState<any>(undefined);
  const [endDate, setEndDate] = useState<any>(undefined);
  const [startSecondaryDateRange, setStartSecondaryDateRange] = useState<any>(
    undefined
  );
  const [endSecondaryDateRange, setEndSecondaryDateRange] = useState<any>(
    undefined
  );
  const [standardsAttachments, setStandardsAttachments] = useState<any>([]);
  const [gradedItems, setGradedItems] = useState<any>([]);
  const [isRoomType, setIsRoomType] = useState('Room Number/Name');
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [
    showSubmitConfirmationModal,
    setShowSubmitConfirmationModal,
  ] = useState<boolean>(false);
  const [taggedUsers, setTaggedUsers] = useState<ISelectedOption[]>([]);
  let standardOrder: number = 0;

  const handleSelectedOptions = (taggedUser: ISelectedOption[]) => {
    const templateCategoryId = subCat.find(
      (cat) => cat.uuid === selectedCategory
    ).id;

    const newTaggedUsers = taggedUser.map((user) => {
      return {
        id: user.id,
        text: user.text,
        templateCategoryId,
      };
    });

    setTaggedUsers(newTaggedUsers);
  };

  const userAssessed = async (res) => {
    const assessedData: any = [];
    const taggedUserArray: ISelectedOption[] = [];
    if (res.duplicateCategoryAssessed) {
      for await (const item of res.duplicateCategoryAssessed) {
        const profileImg = '';
        assessedData.push({ ...item, id: item.userId, profileImg });
        taggedUserArray.push({
          userLastName: item.userLastName,
          userFirstName: item.userFirstName,
          text: `${item.userFirstName} ${item.userLastName}`,
          id: item.userId,
          templateCategoryId: item.templateCategoryId,
        });
      }
    }
    setTaggedUsers(taggedUserArray);
    setAssessed(assessedData);
    setSelfAssessment(res);
  };
  useEffect(() => {
    const tag: any =
      roomNumberOrOutlet[
      template &&
      template.category.find(
        (cat) =>
          cat.categoryType === 'category' && cat.uuid === selectedCategoryId
      ).value
        ];
    setIsRoomType(tag);
  }, [JSON.stringify(template), selectedCategoryId]);

  useEffect(() => {
    if (
      selfAssessment &&
      selfAssessment.duplicateCategories &&
      selfAssessment.duplicateCategories.length > 0 &&
      selectedCategory
    ) {
      const seindex = selfAssessment.duplicateCategories.findIndex(
        (cat) => cat.templateCategoryUuid === selectedCategory
      );
      setSelectedIndex(seindex);
    }
  }, [selfAssessment && selfAssessment.duplicateCategories, selectedCategory]);

  useEffect(() => {
    if (assessmentId) {
      const categoryFilter = template.category.filter(
        (o) => o.categoryType === 'category'
      )[0];
      setSubCat(
        template.category.filter((o) =>
          categoryFilter.categories.includes(o.uuid)
        )
      );
      setSelectedCategory(
        template.category.filter((o) =>
          categoryFilter.categories.includes(o.uuid)
        )[0].uuid
      );
      userAssessed(assess);

      assess.duplicateCategories.map((cat) => {
        if (cat.scores.length > 0) {
          cat.scores.map((item) => {
            setGradedItems((oldState) => [
              ...oldState,
              item.templateStandardUuid,
            ]);
          });
        }
      });
    }
    handleTabs(0, categoryId);
    handleSubTabs(10);
  }, []);

  const getStandardAttachment = (
    duplicateCategoryId,
    templateStandardId,
  ) => {
    if (!templateStandardId) {
      return;
    }
    getSelfAssessmentAttachmentForStandard(
      assessmentId,
      duplicateCategoryId,
      templateStandardId
    )
      .then((response) => {
        setStandardsAttachments(prev => [...prev,
          {
            duplicateCategoryId,
            templateStandardId,
            attachments: response,
          }]
        );
      })
      .catch((error) => {
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t('Unable to get attachments'),
          path: '/editSelfAssessment',
        });
        showErrorMessage('Unable to get attachments');
      });
  };

  useEffect(() => {
    if (selfAssessment && selectedCategory) {
      const duplicateCategory = selfAssessment.duplicateCategories.find(
        (o) => o.templateCategoryUuid === selectedCategory
      );
      const commentList = duplicateCategory.selfAssessmentComments;
      const comment = commentList.filter((k) => !!k);
      setSelfAssessmentComment(
        comment && comment.length > 0 && comment[0] ? comment[0].response : ''
      );
    }
  }, [selfAssessment, selectedCategory]);

  useEffect(() => {
    if (selfAssessment) {
      setStandardsAttachments([]);
      setStandardsAttachmentsIds([]);
      if (
        selfAssessment.duplicateCategories.find(
          (o) => o.templateCategoryUuid === selectedCategory
        ) &&
        selfAssessment.duplicateCategories.find(
          (o) => o.templateCategoryUuid === selectedCategory
        ).id
      ) {
        const subDepartment = selfAssessment.duplicateCategories.find(
          (duplicateCategory) =>
            duplicateCategory.templateCategoryUuid === selectedCategory
        );

        getSelfAssessmentAttachments(assessmentId, subDepartment.id)
          .then((response) => {
            const filteredAttachments = response.filter(
              (attachment) => attachment.url
            );
            setAttachments(filteredAttachments);
          })
          .catch((error) => {
            sentryReport(error.response.data, error.message, error.code, {
              summaryError: t('Unable to get attachments'),
              path: '/editSelfAssessment',
            });
            showErrorMessage('Unable to get attachments', !isUnauthorized(error));
          })
          .finally(() => {
            setAttachmentLoader(false);
          });
      }
    }
    if (subCat) {
      refreshSelfAssessmentAttachmentsListOfStandards();
    }
  }, [selectedCategory, isAttachmentUpdated]);

  useEffect(() => {
    if (!selfAssessment || !selfAssessment.duplicateCategories) {
      return;
    }
    const duplicateCategory = normalizeDuplicateCategory(
      selfAssessment.duplicateCategories[selectedIndex]
    );
    const {
      date,
      dateTime,
      fromDate,
      toDate,
      fromDate2,
      toDate2,
    } = duplicateCategory;
    setDateValue(date || null);
    setDateTime(dateTime || null);
    setStartDate(fromDate || null);
    setEndDate(toDate || null);
    setStartSecondaryDateRange(fromDate2 || null);
    setEndSecondaryDateRange(toDate2 || null);
    if (template) {
      const selectedCategoryData = template.category.find(
        (category) => category.uuid === selectedCategory
      );
      if (selectedCategoryData) {
        const { isDateTimeRequired, dateTimeFormat } = selectedCategoryData;
        setHasDate(isDateTimeRequired && dateTimeFormat === 'date');
        setHasDateTime(isDateTimeRequired && dateTimeFormat === 'dateTime');
        setHasDateRange(
          isDateTimeRequired && dateTimeFormat === 'dateOnlyRange'
        );
        setHasSecondaryDateRange(
          isDateTimeRequired &&
          dateTimeFormat &&
          fromDate2 &&
          toDate2 === 'dateOnlyRange'
        );
        setShouldShowDate(isDateTimeRequired);
      }
    }
    refreshSelfAssessmentAttachmentsListOfStandards();
  }, [selfAssessment, selectedIndex, template, selectedCategory]);

  const refreshSelfAssessmentAttachmentsListOfStandards = () => {
    const duplicateCategory = selfAssessment.duplicateCategories.find(
      (o) => o.templateCategoryUuid === selectedCategory
    );
    getSelfAssessmentAttachmentsListOfStandards(
      assessmentId,
      duplicateCategory.id
    )
      .then((data) => {
        setStandardsAttachmentsIds(data);
        data.map((item) => {
          getStandardAttachment(
            item.duplicateCategoryId,
            item.templateStandardId,
          );
        });
      })
      .catch((err) => console.error(err));
  };

  const labelValue = (value) => {
    switch (value) {
      case 1:
        return '1 Point- Extremely Dissatisfied';
      case 2:
        return '2 Points- Dissatisfied';
      case 3:
        return '3 points- Engaged';
      case 4:
        return '4 Points- Positively Engaged';
      case 5:
        return '5 Points - Completely Engaged';
      default:
        return '';
    }
  };

  const handleTabs = (index, id) => {
    if (!checkForMissingTemplateEqId()) {
      return;
    }
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!collapse[index]) {
      collapse[index] = true;
      setSelectedCategoryId(id);
    } else {
      if (collapse[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
        setSelectedCategoryId(id);
      }
    }
    settoggleTab(collapse);
  };

  const handleSubTabs = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!collapse[index]) {
      collapse[index] = true;
    } else {
      if (collapse[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }
    settoggleSubTab(collapse);
  };

  const CSVToArray = (data, delimiter = ',', omitFirstRow = false) => {
    if (data === '' || data.length < 1) {
      return [];
    }
    if (isArray(data)) {
      return data;
    }
    return data
      .slice(omitFirstRow ? data.indexOf('\n') + 1 : 0)
      .split('\n')
      .map((v) => v.split(delimiter));
  };

  const getScore = (templateStandardUuid: string, scoreList) =>
    scoreList.find(
      (item) => item.templateStandardUuid === templateStandardUuid
    );

  const getCommentries = (templateStandardUuid: string, commentaryList) =>
    commentaryList.find(
      (item) =>
        (item.templateStandarduuid === templateStandardUuid ||
          item.referenceUuid === templateStandardUuid) &&
        item.commentaryType === 'templateStandard'
    );

  let met = 0;
  let notmet = 0;
  let na = 0;
  let numerator = 0;
  let denominator = 0;
  let totalStandards = 0;
  let isNa = false;
  const getMaxValue = (scoreTypeArr, scoringKey): number => {
    return scoreTypeArr &&
    scoreTypeArr.find((o) => o.uuid === scoringKey) &&
    scoreTypeArr.find((o) => o.uuid === scoringKey).maxValue
      ? scoreTypeArr.find((o) => o.uuid === scoringKey).maxValue
      : 0;
  };
  const getScoreCout = (score, maxValue) => {
    let isCal = false;
    if (
      score &&
      score.response &&
      score.response != null &&
      score.response > 0
    ) {
      numerator += score.response;
      denominator += score.range ? score.range : 0;
      met += score.response;
      isCal = true;
    }
    if (score && score.response < maxValue && score.response !== null) {
      if (!isCal) {
        numerator += score.response;
        denominator += score.range ? score.range : 0;
      }
      notmet += maxValue - score.response;
    }
    if (score && score.response === null) {
      na += maxValue;
      isNa = true;
    }
  };
  const getScores = (
    templateStandardUuid: string,
    scoreList,
    scoringType,
    itemData
  ) => {
    const score = scoreList.find(
      (item) => item.templateStandardUuid === templateStandardUuid
    );
    if (score && score.range === undefined) {
      const scoreType = scoringType.find((o) => o.uuid === itemData);
      if (scoreType && scoreType.range) {
        score.range = scoreType.range.max;
      } else {
        score.range = scoreType && scoreType.maxValue ? scoreType.maxValue : 0;
      }
    }
    return score;
  };

  if (template && selfAssessment) {
    template.category
      .find((category) => category.uuid === selectedCategory)
      .items.map((item, index) => {
      if (item.schema === 'templateStandard' && item.isVisible) {
        const stdid = template.templateStandard.find(
          (templateStandard) => templateStandard.uuid === item.id
        ).standard;
        const std = template.standard.find(
          (standard) => standard.uuid === stdid
        );
        const itemScoring = std && std.scoringType;
        const duplicateCategory = selfAssessment.duplicateCategories.find(
          (duplicateCategory) =>
            duplicateCategory.templateCategoryUuid === selectedCategory
        );
        const scoreList = duplicateCategory.scores;
        const score: any = getScores(
          item.id,
          scoreList,
          template.scoringType,
          itemScoring
        );

        const maxValue = getMaxValue(template.scoringType, itemScoring);

        getScoreCout(score, maxValue);
        totalStandards += maxValue;
      }
    });
  }

  const data = {
    stats: [
      {
        label: t('COMMON.SELF_ASSESSMENT.SCORE.POINTS'),
        key: t('COMMON.SELF_ASSESSMENT.SCORE.POINTS'),
        keyValue: t('COMMON.SELF_ASSESSMENT.SCORE.POINTS'),
        value: totalStandards,
        isPercentage: false,
        isSeparated: false,
        backgroundColor: 'platinum',
      },
      {
        label: t('COMMON.SELF_ASSESSMENT.SCORE.MET'),
        key: t('COMMON.SELF_ASSESSMENT.SCORE.MET'),
        keyValue: t('COMMON.SELF_ASSESSMENT.SCORE.MET'),
        value: met,
        isPercentage: false,
        isSeparated: true,
        backgroundColor: 'verdigris',
      },
      {
        label: t('COMMON.SELF_ASSESSMENT.SCORE.NOT_MET'),
        key: t('COMMON.SELF_ASSESSMENT.SCORE.NOT_MET'),
        keyValue: t('COMMON.SELF_ASSESSMENT.SCORE.NOT_MET'),
        value: notmet,
        isPercentage: false,
        isSeparated: false,
        backgroundColor: 'redCrayola',
      },
      {
        label: t('COMMON.SELF_ASSESSMENT.SCORE.NA'),
        key: t('COMMON.SELF_ASSESSMENT.SCORE.NA'),
        keyValue: t('COMMON.SELF_ASSESSMENT.SCORE.NA'),
        value: na,
        isPercentage: false,
        isSeparated: false,
        backgroundColor: 'battleShipGray',
      },
    ],
  };
  const statBlocks = data.stats.map((s) => {
    return {
      label: s.label,
      key: s.label,
      keyValue: s.label,
      backgroundColor: s.backgroundColor,
      value: `${s.value}` + (s.isPercentage ? '%' : ''),
      separated: s.isSeparated,
      intent:
        s.label === t('COMMON.SELF_ASSESSMENT.SCORE.MET')
          ? 'green'
          : s.label === t('COMMON.SELF_ASSESSMENT.SCORE.NOT_MET')
            ? 'red'
            : s.label === t('COMMON.SELF_ASSESSMENT.SCORE.NA')
              ? 'grey'
              : '',
    };
  });
  const getScoreValue = (d, n, isNaAvailable, scoreStr) => {
    return d === 0 && n === 0 && isNaAvailable === true
      ? t('COMMON.SELF_ASSESSMENT.SCORE.NA')
      : scoreStr + '%';
  };
  let scorePer = (numerator / denominator) * 100;
  scorePer = scorePer > 100 ? 100 : scorePer;
  const scorePerStr = isNaN(scorePer) ? '0' : round(scorePer, 1).toFixed(1);
  statBlocks.unshift({
    key: t('COMMON.SELF_ASSESSMENT.SCORE.LABEL'),
    keyValue: t('COMMON.SELF_ASSESSMENT.SCORE.LABEL'),
    value: getScoreValue(denominator, numerator, isNa, scorePerStr),
    label: t('COMMON.SELF_ASSESSMENT.SCORE.LABEL'),
    backgroundColor: 'platinum',
    separated: false,
    intent: '',
  });

  const getRange = (item, scoringTypeId) => {
    let range;

    if (item && item.range === undefined) {
      const scoreType = template.scoringType.find(
        (o) => o.id === scoringTypeId
      );
      if (scoreType && scoreType.range) {
        range = scoreType.range.max;
      } else {
        range = scoreType && scoreType.maxValue ? scoreType.maxValue : 0;
      }
    }
    return range;
  };

  const checkForMissingTemplateEqId = (): boolean => {
    const textInputFields = [
      'positiveText',
      'negativeText',
      'recommendText',
      'additionalText',
    ];
    if (!selfAssessment || !selfAssessment.duplicateCategories) {
      return true;
    }
    const matchingCategory = selfAssessment.duplicateCategories.find(
      (category) => category.templateCategoryUuid === selectedCategory
    );
    if (!matchingCategory || !matchingCategory.assessmentEq) {
      return true;
    }
    const hasMissingTemplateId = textInputFields.some(
      (field) =>
        matchingCategory.assessmentEq[field] &&
        !matchingCategory.assessmentEq.templateEqId
    );
    if (hasMissingTemplateId) {
      showErrorMessage(t('COMMON.SELF_ASSESSMENT.MESSAGES.SELECT_EQ_RATING'));
      return false;
    }
    return true;
  };

  const handleEqCommnetary = (key, eqComment) => {
    let eqDescOptions;
    if (key === 'templateEqId') {
      eqDescOptions = CSVToArray(
        template &&
        template.template.templateEqList &&
        template.template.templateEqList.find((o) => o.id === eqComment)
          .description
      )[0];
    }
    const data = { ...selfAssessment };
    const dataAssEq = data.duplicateCategories.map(
      (category, indexDuplicateCategories) => {
        if (key === 'roomNumber') {
          if (indexDuplicateCategories == selectedIndex) {
            category.roomNumber = eqComment;
            delete category.outlet;
            return category;
          }
          return category;
        } else if (key === 'outletName') {
          if (indexDuplicateCategories == selectedIndex) {
            category.outlet = eqComment;
            delete category.roomNumber;
            return category;
          }
          return category;
        } else if (category.templateCategoryUuid === selectedCategory) {
          let eq;
          if (category.assessmentEq) {
            eq = {
              ...category.assessmentEq,
              [key]: eqComment,
              categoryEqDescription:
                key === 'templateEqId'
                  ? eqDescOptions[0]
                  : key === 'categoryEqDescription'
                    ? eqComment
                    : category.assessmentEq &&
                    category.assessmentEq.categoryEqDescription
                      ? category.assessmentEq.categoryEqDescription
                      : '',
            };
          } else {
            eq = {
              ...{
                uuid: uuid(),
                duplicateCategoryUuid: category.uuid,
                templateCategoryUuid: selectedCategory,
                templateEqId: '',
                categoryEqDescription: '',
                positiveText: '',
                negativeText: '',
                recommendText: '',
                additionalText: '',
              },
              [key]: eqComment,
              categoryEqDescription:
                key === 'templateEqId'
                  ? eqDescOptions[0]
                  : key === 'categoryEqDescription'
                    ? eqComment
                    : category.assessmentEq &&
                    category.assessmentEq.categoryEqDescription
                      ? category.assessmentEq.categoryEqDescription
                      : '',
            };
          }

          const {
            positiveText,
            negativeText,
            recommendText,
            additionalText,
            templateEqId,
          } = eq;
          if (
            !positiveText &&
            !negativeText &&
            !recommendText &&
            !additionalText &&
            !templateEqId
          ) {
            const { assessmentEq, ...rest } = category;
            return rest;
          } else {
            return {
              ...category,
              assessmentEq: eq,
            };
          }
        } else {
          return category;
        }
      }
    );
    setSelfAssessment({ ...selfAssessment, duplicateCategories: dataAssEq });
  };

  const handleCommnetary = (comment) => {
    setItem('isFormData', true);
    const data = { ...selfAssessment };
    const dC = data.duplicateCategories.map((o) => {
      if (o.templateCategoryUuid === selectedCategory) {
        let found = false;
        const co = o.selfAssessmentComments
          .filter((k) => !!k)
          .map((item) => {
            if (
              item.duplicateCategoryUuid === o.uuid &&
              item.commentaryType === 'selfAssessmentClientComm'
            ) {
              found = true;
              return {
                ...item,
                response: comment,
              };
            } else {
              return { ...item };
            }
          });
        if (!found) {
          co.push({
            uuid: uuid(),
            duplicateCategoryUuid: o.uuid,
            referenceUuid: o.uuid,
            commentaryType: 'selfAssessmentClientComm',
            response: comment,
          });
        }
        return {
          ...o,
          selfAssessmentComments: co,
        };
      } else {
        return o;
      }
    });
    setSelfAssessment({ ...selfAssessment, duplicateCategories: dC });
  };
  const handleStandardCommentary = (stdcomment, itmsid) => {
    setItem('isFormData', true);
    const itmemss = template.templateStandard.find((o) => o.uuid === itmsid);
    const templateStandardUuid = itmemss.uuid;
    const data = { ...selfAssessment };
    const dC = data.duplicateCategories.map((o) => {
      if (o.templateCategoryUuid === selectedCategory) {
        let found = false;
        const co = o.commentaries.map((item) => {
          if (
            (item.templateStandarduuid === templateStandardUuid ||
              item.referenceUuid === templateStandardUuid) &&
            item.commentaryType === 'templateStandard'
          ) {
            found = true;
            return {
              ...item,
              response: stdcomment,
            };
          } else {
            return { ...item };
          }
        });
        if (!found) {
          co.push({
            uuid: uuid(),
            duplicateCategoryUuid: o.uuid,
            referenceUuid: templateStandardUuid,
            commentaryType: 'templateStandard',
            response: stdcomment,
          });
        }
        return {
          ...o,
          commentaries: co,
        };
      } else {
        return o;
      }
    });
    setSelfAssessment({ ...selfAssessment, duplicateCategories: dC });
  };

  const handleMarking = (response, standardId, scoringTypeId) => {
    setItem('isFormData', true);
    setGradedItems([...gradedItems, standardId]);
    const templateStandard = template.templateStandard.find(
      (standard) => standard.uuid === standardId
    );
    const templateStandardUuid = templateStandard.uuid;

    const copySelfAssessment = { ...selfAssessment };
    const duplicateCategories = copySelfAssessment.duplicateCategories.map(
      (duplicatedCategory) => {
        if (duplicatedCategory.templateCategoryUuid === selectedCategory) {
          let found = false;
          const scores = duplicatedCategory.scores.map((score) => {
            if (
              score.templateStandardUuid === templateStandardUuid &&
              score.response !== response
            ) {
              found = true;
              return {
                ...score,
                range: getRange(score, scoringTypeId),
                response,
              };
            } else {
              return {
                ...score,
                range: getRange(score, scoringTypeId),
              };
            }
          });
          if (!found && scoringTypeId !== 700) {
            scores.push({
              uuid: uuid(),
              duplicateCategoryUuid: duplicatedCategory.uuid,
              templateStandardUuid,
              templateStandardId: templateStandard.id,
              response,
              range: 1,
            });
          }
          return {
            ...duplicatedCategory,
            scores,
          };
        } else {
          return duplicatedCategory;
        }
      }
    );
    setSelfAssessment({ ...selfAssessment, duplicateCategories });
  };

  const handleUngradedMarking = async () => {
    const subCats = template.category.filter(
      (o) => o.categoryType === 'subCategory'
    );
    const data = { ...selfAssessment };
    const dC = await Promise.all(
      data.duplicateCategories.map((o) => {
        const selSubCat = subCats.find((k) => k.uuid == o.templateCategoryUuid);
        selSubCat.items.map((ungradedItem) => {
          if (
            ungradedItem.schema === 'templateStandard' &&
            ungradedItem.isVisible &&
            ungradedItem.scoringType != 700 &&
            !gradedItems.includes(ungradedItem.id)
          ) {
            const itemPushed = template.templateStandard.find(
              (j) => j.uuid === ungradedItem.id
            );
            o.scores.push({
              uuid: uuid(),
              duplicateCategoryUuid: o.uuid,
              templateStandardUuid: itemPushed.uuid,
              templateStandardId: itemPushed.id,
              response: null,
              range: 1,
            });
          }
        });
        return {
          ...o,
        };
      })
    );
    setSelfAssessment({ ...selfAssessment, duplicateCategories: dC });
  };

  const calculateSelfAssessmentPercentages = () => {
    setItem('isFormData', false);
    const scoreD = selfAssessment.duplicateCategories.map((o) => o.scores);
    const scores = scoreD.reduce((acc, curVal) => {
      return acc.concat(curVal);
    }, []);
    const duplicateCat = selfAssessment.duplicateCategories.map((o) => {
      const score = o.scores.map((k) => k.uuid);
      const commentary = o.commentaries.map((k) => k.uuid);
      return {
        ...o,
        scores: score,
        commentaries: commentary,
      };
    });
    const completedPercentage = getAssessmentPercentageCompleted(
      duplicateCat,
      template.category,
      [],
      scores,
      [],
      [],
      'self'
    );

    return completedPercentage;
  };

  const normalizeDuplicateCategory = (duplicateCategory) => {
    const defaultValues = {
      date: null,
      dateTime: null,
      fromDate: null,
      toDate: null,
      fromDate2: null,
      toDate2: null,
    };

    return { ...defaultValues, ...duplicateCategory };
  };

  const handleDateChange = (key, value) => {
    setSelfAssessment((prev) => {
      const updatedCategories = prev.duplicateCategories.map(
        (category, index) => {
          if (index === selectedIndex) {
            if (key === 'fromDate') {
              return { ...category, [key]: value || null, toDate: null };
            }
            return { ...category, [key]: value || null };
          }
          return category;
        }
      );
      return { ...prev, duplicateCategories: updatedCategories };
    });
  };

  const handleSave = (submit = false) => {
    if (!checkForMissingTemplateEqId()) {
      return false;
    }
    setItem('isFormData', false);
    if (submit) {
      setIsLoading(false);
      handleUngradedMarking();
    } else {
      setIsLoading(true);
    }
    const scoreD = selfAssessment.duplicateCategories.map((o) => o.scores);
    const scores = scoreD.reduce((acc, curVal) => {
      return acc.concat(curVal);
    }, []);

    const commentariesD = selfAssessment.duplicateCategories.map(
      (o) => o.commentaries
    );
    const commentaries = commentariesD.reduce((acc, curVal) => {
      return acc.concat(curVal);
    }, []);
    const assessmentEqD = selfAssessment.duplicateCategories.map(
      (o) => o.assessmentEq
    );
    const eqData = assessmentEqD.reduce((acc, curVal) => {
      return acc.concat(curVal);
    }, []);
    const selfcommentariesD = selfAssessment.duplicateCategories.map(
      (o) => o.selfAssessmentComments
    );
    const selfcommentaries = selfcommentariesD.reduce((acc, curVal) => {
      return acc.concat(curVal);
    }, []);

    const duplicateCat = selfAssessment.duplicateCategories.map(
      (duplicateCategory) => {
        const score = duplicateCategory.scores.map((score) => score.uuid);
        const commentary = duplicateCategory.commentaries.map(
          (comment) => comment.uuid
        );
        return {
          ...duplicateCategory,
          scores: score,
          commentaries: commentary,
          ...(duplicateCategory.templateCategoryUuid === selectedCategory && {
            date: dateValue,
            dateTime,
            fromDate: startDate,
            toDate: endDate,
            fromDate2: startSecondaryDateRange,
            toDate2: endSecondaryDateRange,
          }),
        };
      }
    );

    const duplicateCategoryAssessed = taggedUsers.reduce(
      (
        acc: { userId: Nullable<number>; templateCategoryId?: number }[],
        option: ISelectedOption
      ) => {
        if (!acc.some((user) => user.userId === option.id)) {
          acc.push({
            userId: option.id,
            templateCategoryId: option.templateCategoryId,
          });
        }
        return acc;
      },
      []
    );
    const payLoad = {
      percentageCompleted: getAssessmentPercentageCompleted(
        duplicateCat,
        template.category,
        [],
        scores,
        [],
        [],
        'self'
      ),
      selfAssessmentCommentary: selfcommentaries.filter((o) => !!o),
      commentaries,
      scores,
      duplicateCategories: duplicateCat,
      assessmentEqList: eqData.filter((o) => !!o),
      templateId: template.template.id,
      isClientApp: true,
      duplicateCategoryAssessed,
    };
    if (parentId) {
      editSelfAssessmentWithParent(assessmentId, parentId, payLoad)
        .then(async (response) => {
          setSelfAssessment(response);
          setItem('percentageCompleted', {
            percentageCompleted: getAssessmentPercentageCompleted(
              duplicateCat,
              template.category,
              [],
              scores,
              [],
              [],
              'self'
            ),
            perComId: response.id,
          });
          if (submit) {
            handleSubmitSelfAssessment(assessmentId);
            navigate('/myactions');
          }
          setIsLoading(false);
          setSubmitLoading(false);
          if (submit) {
            showSuccessMessage('Self Assessment submitted successfully.');
          } else {
            showSuccessMessage('Self Assessment saved successfully.');
          }
          if (assessed.length) {
            const assessedData: any = [];
            for await (const item of assessed) {
              const profileImg = '';
              assessedData.push({ ...item, userId: item.id, profileImg });
            }
          } else {
            setAssessed([]);
          }
        })
        .catch((e) => {
          showErrorMessage('Please fill all required fields.');
          setIsLoading(false);
          setSubmitLoading(false);
        });
    } else {
      editSelfAssessment(assessmentId, payLoad)
        .then(async (response) => {
          setSelfAssessment(response);
          setItem('percentageCompleted', {
            percentageCompleted: getAssessmentPercentageCompleted(
              duplicateCat,
              template.category,
              [],
              scores,
              [],
              [],
              'self'
            ),
            perComId: response.id,
          });
          if (submit) {
            handleSubmitSelfAssessment(assessmentId);
            navigate('/myactions');
          }
          setIsLoading(false);
          setSubmitLoading(false);
          if (submit) {
            showSuccessMessage('Self Assessment submitted successfully.');
          } else {
            showSuccessMessage('Self Assessment saved successfully.');
          }
          if (assessed.length) {
            const assessedData: any = [];
            for await (const item of assessed) {
              const profileImg = '';
              assessedData.push({ ...item, userId: item.id, profileImg });
            }
          } else {
            setAssessed([]);
          }
        })
        .catch((e) => {
          showErrorMessage('Please fill all required fields.');
          setIsLoading(false);
          setSubmitLoading(false);
        });
    }
    return true;
  };

  const inputImgRef = useRef<HTMLInputElement>(null);
  const [imageFile, setImageFile] = useState(null);
  const [isGridOpen, setIsGridOpen] = useState<boolean>(false);
  const handleImageCompletion = (croppedImage) => {
    handleMediaUpload(
      croppedImage,
      false,
      assessmentId,
      selfAssessment.duplicateCategories.find(
        (duplicateCategory) =>
          duplicateCategory.templateCategoryUuid === selectedCategory
      ).id
    );
    setImageFile(null);
  };

  function handleMediaUpload (
    newImage: Blob | string,
    questionPhoto?: boolean,
    assessmentId?: string | number,
    departmentId?: string | number
  ) {
    setAttachmentLoader(true);
    const formData = new FormData();
    formData.append('file', newImage);
    uploadSelfAssessmentAttachment(assessmentId, departmentId, formData)
      .then((response) => {
        setIsAttachmentUpdated(!isAttachmentUpdated);
        showSuccessMessage(t('COMMON.ALERT_MESSAGES.UPLOADED_SUCCESSFULLY'));
      })
      .catch((error) => {
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t('COMMON.ALERT_MESSAGES.ATTACHMENT_ERROR'),
          path: '/myaudit/conduct/${auditId}',
        });
        showErrorMessage(t('COMMON.ALERT_MESSAGES.ATTACHMENT_ERROR'));
      })
      .finally(() => {
        setAttachmentLoader(false);
      });
  }

  const handleDeleteImage = (
    index?: number,
    fileId?: number,
    questionPhoto?: boolean,
    standardId?: string | number,
    fileName?: string
  ) => {
    setAttachmentLoader(true);
    deleteSelfAssessmentAttachment(
      assessmentId,
      selfAssessment.duplicateCategories.find(
        (o) => o.templateCategoryUuid === selectedCategory
      ).id,
      fileId,
      fileName
    )
      .then(() => {
        if (parentId) {
          deleteSelfAssessmentAttachment(
            parentId,
            selfAssessment.duplicateCategories.find(
              (o) => o.templateCategoryUuid === selectedCategory
            ).id,
            fileId,
            fileName
          )
            .then(() => {})
            .catch((e) => {
              showErrorMessage('Attachment remove failed');
            });
        }

        setIsAttachmentUpdated(!isAttachmentUpdated);
        if (attachments.length === 0) {
          setIsGridOpen(false);
        }
        showSuccessMessage(t('COMMON.ALERT_MESSAGES.DELETED_SUCCESSFULLY'));
      })
      .catch((error) => {
        setAttachmentLoader(false);
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t('COMMON.ALERT_MESSAGES.UNABLE_TO_DELETE'),
          path: '/myaudit/conduct/${auditId}',
        });
        showErrorMessage(t('COMMON.ALERT_MESSAGES.UNABLE_TO_DELETE'));
      });
  };

  const handleOpenGrid = () => {
    if (attachments.length > 0) {
      setIsGridOpen(!isGridOpen);
    }
  };

  return (
    <AssessmentStandarContainer>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.SELF_ASSESSMENT.TITLES.SELF_ASSESSMENT')}
          navigateTo={'/SelfAssessments/received/false/all'}
        />
      </HeaderContainer>
      {showSubmitConfirmationModal && (
        <Modal
          isOpen={showSubmitConfirmationModal}
          handleModalClose={() => setShowSubmitConfirmationModal(false)}
        >
          <ModalHeader>
            <Headline3>
              {t(
                'COMMON.SELF_ASSESSMENT.MESSAGES.SUBMIT_SELF_ASSESSMENT_CONFIRMATION'
              )}
            </Headline3>
          </ModalHeader>
          {calculateSelfAssessmentPercentages() < 100 && (
            <ModalContent>
              <Body4>
                {t(
                  'COMMON.SELF_ASSESSMENT.MESSAGES.SUBMIT_SELF_ASSESSMENT_CONFIRMATION_NOTE'
                )}
              </Body4>
            </ModalContent>
          )}
          <ButtonBlockColumn>
            <ButtonLarge
              title={t('COMMON.SELF_ASSESSMENT.BUTTON.SUBMIT')}
              onClick={() => {
                setSubmitLoading(true);
                handleSave(true);
                setShowSubmitConfirmationModal(false);
              }}
              backgroundColor="oxfordBlue"
            />
            <ButtonLarge
              title={t('COMMON.SELF_ASSESSMENT.BUTTON.EDIT_SELF_ASSESSMENT')}
              onClick={() => setShowSubmitConfirmationModal(false)}
              outlined={true}
              inverted={true}
            />
            <ButtonLarge
              title={t('COMMON.OUTSIDE.BUTTONS.CLOSE')}
              onClick={() => setShowSubmitConfirmationModal(false)}
              outlined={true}
              inverted={true}
            />
          </ButtonBlockColumn>
        </Modal>
      )}
      {!selectedCategory || !subCat || !template || !selfAssessment ? (
        <LoadingContent />
      ) : (
        <ContentArea>
          <Block className="stdcontainer">
            <ScoreContainer>
              <Score scoreList={statBlocks} />
            </ScoreContainer>
            <div className="tabs mt-20">
              <ul className="tabs-ul">
                {template.category
                  .filter((o) => o.categoryType === 'category')
                  .map((tab, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        if (checkForMissingTemplateEqId()) {
                          handleTabs(index, tab.uuid);
                          handleSubTabs(parseInt(`${index + 1}${0}`));
                          setSubCat(
                            template.category.filter((template) =>
                              tab.categories.includes(template.uuid)
                            )
                          );
                          setSelectedCategory(
                            template.category.filter((template) =>
                              tab.categories.includes(template.uuid)
                            )[0].uuid
                          );
                          setCategoryIndex(index + 1);
                        }
                      }}
                      className={`${
                        toggleTab[index] ? 'activeTab' : ''
                      } f-15 lh-20`}
                    >
                      {tab.value}
                    </li>
                  ))}
              </ul>
              <ul className="tabs-ul">
                {subCat &&
                  subCat.map((subCategory, subCategoryIndex) => (
                    <li
                      key={v4()}
                      onClick={() => {
                        if (checkForMissingTemplateEqId()) {
                          handleSubTabs(`${categoryIndex}${subCategoryIndex}`);
                          setSelectedCategory(subCategory.uuid);
                        }
                      }}
                      className={`${
                        toggleSubTab[
                          parseInt(`${categoryIndex}${subCategoryIndex}`)
                          ]
                          ? 'activeSubTab fw-400'
                          : 'fw-600'
                      }  f-10 lh-12`}
                    >
                      {subCategory.value} - Standards
                    </li>
                  ))}
              </ul>
              <div>
                <SubTabContainer>
                  {subCat &&
                    subCat
                      .filter((cat) => cat.uuid === selectedCategory)
                      .map((sub, i) => {
                        const duplicateCategoryData = selfAssessment.duplicateCategories.find(
                          (o) => o.templateCategoryUuid === selectedCategory
                        );
                        const assessmentEq = duplicateCategoryData.assessmentEq;
                        const findTemplateEqId =
                          assessmentEq &&
                          template &&
                          template.template.templateEqList &&
                          template.template.templateEqList.find(
                            (o) => o.id === assessmentEq.templateEqId
                          );
                        const eqDescOpt =
                          assessmentEq && findTemplateEqId
                            ? CSVToArray(findTemplateEqId.description)[0]
                            : [];
                        return (
                          <div key={i}>
                            <div>
                              <div className="d-flex space-between mt-20">
                                <div className="color-58C3BB mb-10 f-20 fw-600 lh-24">
                                  {sub.value} - Standards
                                </div>
                              </div>
                              <div>
                                {isRoomType &&
                                selfAssessment &&
                                isRoomType === 'Room Number/Name' &&
                                selfAssessment.duplicateCategories[
                                  selectedIndex
                                  ].roomNumber !== (null && undefined) ? (
                                  <p className="f-13 pb-5">{`${isRoomType} : ${selfAssessment.duplicateCategories[selectedIndex].roomNumber} `}</p>
                                ) : isRoomType === 'Outlet Name' &&
                                selfAssessment &&
                                selfAssessment.duplicateCategories &&
                                selfAssessment.duplicateCategories[
                                  selectedIndex
                                  ].outlet !== (null && undefined) ? (
                                  <p className="f-13 pb-5">{`${isRoomType} : ${selfAssessment.duplicateCategories[selectedIndex].outlet} `}</p>
                                ) : null}
                              </div>
                              <GridContainer>
                                <Grid
                                  data-testid="button-upload-media"
                                  media={attachments}
                                  onDelete={handleDeleteImage}
                                  isGridOpen={isGridOpen}
                                  handleOpenGrid={handleOpenGrid}
                                />
                                <ButtonMediaUploadWrapper>
                                  <ButtonMediaUpload
                                    title={t(
                                      'COMMON.MY_AUDIT.BUTTON.UPLOAD_MEDIA'
                                    )}
                                    onClick={() =>
                                      inputImgRef.current &&
                                      inputImgRef.current.click()
                                    }
                                    loading={attachmentLoader}
                                  />
                                  <ImageInputContainer
                                    ref={inputImgRef}
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                      if (
                                        e &&
                                        e.target &&
                                        e.target.files &&
                                        e.target.files[0]
                                      ) {
                                        const newImage = e.target.files[0];
                                        if (
                                          e.target.files[0].type.includes(
                                            'image'
                                          )
                                        ) {
                                          setImageFile(newImage);
                                        } else {
                                          handleMediaUpload(
                                            newImage,
                                            false,
                                            assessmentId,
                                            selfAssessment.duplicateCategories.find(
                                              (o) =>
                                                o.templateCategoryUuid ===
                                                selectedCategory
                                            ).id
                                          );
                                        }
                                        if (inputImgRef.current) {
                                          inputImgRef.current.value = '';
                                        }
                                      }
                                    }}
                                  />
                                  {imageFile && (
                                    <Cropper
                                      imageFile={imageFile}
                                      onImageCompletion={handleImageCompletion}
                                      previousImages={attachments}
                                    />
                                  )}
                                </ButtonMediaUploadWrapper>
                              </GridContainer>
                              <hr className="border-top-d1dbec-1" />
                              {showMet && subCat && selectedCategory ? (
                                subCat
                                  .find((o) => o.uuid === selectedCategory)
                                  .items.filter(
                                  (item) =>
                                    item.schema === 'templateStandard' &&
                                    item.isVisible
                                )
                                  .map((itms) => {
                                    if (itms.scoringType !== 700) {
                                      standardOrder += 1;
                                    }
                                    const itmemss = template.templateStandard.find(
                                      (o) => o.uuid === itms.id
                                    );
                                    const duplicateCategory = selfAssessment.duplicateCategories.find(
                                      (o) =>
                                        o.templateCategoryUuid ===
                                        selectedCategory
                                    );
                                    const templateStandardUuid = itmemss.uuid;
                                    const commentryList =
                                      duplicateCategory.commentaries;
                                    const score = getScore(
                                      templateStandardUuid,
                                      duplicateCategory.scores
                                    );
                                    const comment = getCommentries(
                                      templateStandardUuid,
                                      commentryList
                                    );
                                    const standard = template.standard.find(
                                      (o) => itmemss.standard === o.uuid
                                    );
                                    let stndd = { value: '' };
                                    if (!standard) {
                                      const d = template.templateStandardTranslation.find(
                                        (o) =>
                                          itmemss.uuid === o.uuid &&
                                          o.language === 'en'
                                      );
                                      stndd = d ? d : stndd;
                                    } else {
                                      stndd = standard.translations.find(
                                        (o) => o.language === 'en'
                                      );
                                    }
                                    return (
                                      <>
                                        <SelfAssessmentQuestionCard
                                          key={itms.id}
                                          question={{
                                            order: itms.scoringType !== 700 ? standardOrder : 0,
                                            id: itms.id,
                                            uuid: itms.id,
                                            text: stndd.value,
                                            performanceClassification:
                                              standard &&
                                              getLabel[
                                                standard
                                                  .performanceClassification
                                                ],
                                            score: score && score.response,

                                            comments: comment
                                              ? unescape(comment.response)
                                              : '',
                                            scoringTypeId: itms.scoringType,
                                            standardAttachment: (
                                              <StandardAttachment
                                                key={itmemss.id}
                                                assessmentId={assessmentId}
                                                duplicateCategoryId={
                                                  duplicateCategory.id
                                                }
                                                templateStandardId={itmemss.id}
                                                parentId={parentId}
                                                standardsAttachment={
                                                  standardsAttachments
                                                }
                                                standardsAttachmentsIds={
                                                  standardsAttachmentsIds
                                                }
                                                refreshSelfAssessmentAttachmentsListOfStandards={
                                                  refreshSelfAssessmentAttachmentsListOfStandards
                                                }
                                              />
                                            ),
                                          }}
                                          onClickScore={handleMarking}
                                          handleQuestionComment={(
                                            comment,
                                            standardId
                                          ) => {
                                            handleStandardCommentary(
                                              comment,
                                              itms.id
                                            );
                                          }}
                                          showDropdownIcon={
                                            score &&
                                            score.response !== undefined
                                          }
                                        />
                                      </>
                                    );
                                  })
                              ) : (
                                <></>
                              )}
                              {shouldShowDate && (
                                <DatePickerContainer>
                                  <Body5 color="eerieBlack">
                                    {t('COMMON.MY_AUDIT.CONDUCT.DATE.TITLE')}
                                  </Body5>
                                  <DatePickerWrapper>
                                    {hasDate && (
                                      <DatePickerDate
                                        startDate={dateValue}
                                        setStartDate={(date) => {
                                          setDateValue(date);
                                          handleDateChange('date', date);
                                        }}
                                      />
                                    )}
                                    {hasDateTime && (
                                      <DatePickerDateTime
                                        startDate={dateTime}
                                        setStartDate={(date) => {
                                          setDateTime(date);
                                          handleDateChange('dateTime', date);
                                        }}
                                      />
                                    )}
                                    {hasDateRange && (
                                      <DatePickerDateRange
                                        startDate={startDate}
                                        setStartDate={(date) => {
                                          setStartDate(date);
                                          handleDateChange('fromDate', date);
                                        }}
                                        endDate={endDate}
                                        setEndDate={(date) => {
                                          setEndDate(date);
                                          handleDateChange('toDate', date);
                                        }}
                                      />
                                    )}
                                    {hasSecondaryDateRange && (
                                      <DatePickerDateRange
                                        startDate={startSecondaryDateRange}
                                        setStartDate={(date) => {
                                          setStartSecondaryDateRange(date);
                                          handleDateChange('fromDate2', date);
                                        }}
                                        endDate={endSecondaryDateRange}
                                        setEndDate={(date) => {
                                          setEndSecondaryDateRange(date);
                                          handleDateChange('toDate2', date);
                                        }}
                                      />
                                    )}
                                  </DatePickerWrapper>
                                </DatePickerContainer>
                              )}
                              <TextAreaLabel>
                                Self Assessment Comments:
                              </TextAreaLabel>
                              <ControlTextarea
                                minRows={3}
                                style={{
                                  height: '81px !important',
                                  overflow: 'hidden !important',
                                  outline: 'none !important',
                                  color: '#1F1F1F !important',
                                  border: '1px solid #D9D9D9 !important',
                                  borderRadius: '0.5rem !important',
                                  padding: '12px 16px !important',
                                  backgroundColor: '#FFFFFF !important',
                                  fontSize: '13px !important',
                                  fontFamily: 'Source Sans Pro !important',
                                  marginBottom: '16px',
                                }}
                                placeholder="Comments"
                                value={unescape(selfAssessmentComment)}
                                // onChange = {(e) => }
                                onChange={(e) => {
                                  handleCommnetary(escape(e.target.value));
                                }}
                              />
                              <TextAreaLabel>
                                {t('COMMON.EI_BEHAVIORAL.EI_BEHAVIORAL')}:
                              </TextAreaLabel>
                              <ControlSelect
                                className=" h-55px fw-400 f-17 lh-22"
                                placeholder="EQ Rating"
                                value={
                                  assessmentEq && assessmentEq.templateEqId
                                    ? assessmentEq.templateEqId
                                    : ''
                                }
                                onChange={(e) => {
                                  handleEqCommnetary(
                                    'templateEqId',
                                    e.target.value
                                  );
                                }}
                                key={duplicateCategoryData.id + 'Eq'}
                              >
                                {template &&
                                  template.template.templateEqList &&
                                  template.template.templateEqList.map((o) => (
                                    <option key={o.id} value={o.id}>
                                      {labelValue(round(o.value))}
                                    </option>
                                  ))}
                              </ControlSelect>
                              {assessmentEq && assessmentEq.templateEqId && (
                                <ControlSelect
                                  className=" h-55px mb-10 fw-400 f-17 lh-22 no-button"
                                  placeholder="Emotional Indicator"
                                  value={
                                    assessmentEq &&
                                    assessmentEq.categoryEqDescription
                                      ? assessmentEq.categoryEqDescription
                                      : eqDescOpt.length
                                        ? eqDescOpt[0]
                                        : ''
                                  }
                                  onChange={(e) => {
                                    handleEqCommnetary(
                                      'categoryEqDescription',
                                      e.target.value
                                    );
                                  }}
                                  key={duplicateCategoryData.id + 'EqDesc'}
                                >
                                  <option />
                                  {assessmentEq &&
                                    assessmentEq.templateEqId &&
                                    template &&
                                    template.template.templateEqList &&
                                    template.template.templateEqList.find(
                                      (o) => o.id === assessmentEq.templateEqId
                                    ) &&
                                    CSVToArray(
                                      template &&
                                      template.template.templateEqList &&
                                      template.template.templateEqList.find(
                                        (o) =>
                                          o.id === assessmentEq.templateEqId
                                      ).description
                                    )[0].map((o) => (
                                      <option key={o} value={o}>
                                        {o}
                                      </option>
                                    ))}
                                </ControlSelect>
                              )}
                              <TextAreaLabel>Additional Text:</TextAreaLabel>
                              <ControlTextarea
                                style={{
                                  height: '81px !important',
                                  overflow: 'hidden !important',
                                  outline: 'none !important',
                                  color: '#1F1F1F !important',
                                  border: '1px solid #D9D9D9 !important',
                                  borderRadius: '0.5rem !important',
                                  padding: '12px 16px !important',
                                  backgroundColor: '#FFFFFF !important',
                                  fontSize: '13px !important',
                                  fontFamily: 'Source Sans Pro !important',
                                  marginBottom: '16px',
                                }}
                                minRows={3}
                                placeholder="Additional Text"
                                value={
                                  assessmentEq && assessmentEq.additionalText
                                    ? unescape(assessmentEq.additionalText)
                                    : ''
                                }
                                onChange={(e) => {
                                  handleEqCommnetary(
                                    'additionalText',
                                    escape(e.target.value)
                                  );
                                }}
                              />
                              <TextAreaLabel>Positive Text:</TextAreaLabel>
                              <ControlTextarea
                                placeholder="Positive Text"
                                style={{
                                  height: '81px !important',
                                  overflow: 'hidden !important',
                                  outline: 'none !important',
                                  color: '#1F1F1F !important',
                                  border: '1px solid #D9D9D9 !important',
                                  borderRadius: '0.5rem !important',
                                  padding: '12px 16px !important',
                                  backgroundColor: '#FFFFFF !important',
                                  fontSize: '13px !important',
                                  fontFamily: 'Source Sans Pro !important',
                                  marginBottom: '16px',
                                }}
                                minRows={3}
                                value={
                                  assessmentEq && assessmentEq.positiveText
                                    ? unescape(assessmentEq.positiveText)
                                    : ''
                                }
                                onChange={(e) => {
                                  handleEqCommnetary(
                                    'positiveText',
                                    escape(e.target.value)
                                  );
                                }}
                              />
                              <TextAreaLabel>Negative Text:</TextAreaLabel>
                              <ControlTextarea
                                style={{
                                  height: '81px !important',
                                  overflow: 'hidden !important',
                                  outline: 'none !important',
                                  color: '#1F1F1F !important',
                                  border: '1px solid #D9D9D9 !important',
                                  borderRadius: '0.5rem !important',
                                  padding: '12px 16px !important',
                                  backgroundColor: '#FFFFFF !important',
                                  fontSize: '13px !important',
                                  fontFamily: 'Source Sans Pro !important',
                                  marginBottom: '16px',
                                }}
                                placeholder="Negative Text"
                                minRows={3}
                                value={
                                  assessmentEq && assessmentEq.negativeText
                                    ? unescape(assessmentEq.negativeText)
                                    : ''
                                }
                                onChange={(e) => {
                                  handleEqCommnetary(
                                    'negativeText',
                                    escape(e.target.value)
                                  );
                                }}
                              />
                              <TextAreaLabel>Recommendations:</TextAreaLabel>
                              <ControlTextarea
                                style={{
                                  height: '81px !important',
                                  overflow: 'hidden !important',
                                  outline: 'none !important',
                                  color: '#1F1F1F !important',
                                  border: '1px solid #D9D9D9 !important',
                                  borderRadius: '0.5rem !important',
                                  padding: '12px 16px !important',
                                  backgroundColor: '#FFFFFF !important',
                                  fontSize: '13px !important',
                                  fontFamily: 'Source Sans Pro !important',
                                  marginBottom: '16px',
                                }}
                                placeholder="Recommendation Text "
                                minRows={3}
                                value={
                                  assessmentEq && assessmentEq.recommendText
                                    ? unescape(assessmentEq.recommendText)
                                    : ''
                                }
                                onChange={(e) => {
                                  handleEqCommnetary(
                                    'recommendText',
                                    escape(e.target.value)
                                  );
                                }}
                              />
                              {/* rafael */}
                              <div className="assessed-wrapper">
                                <SearchBoxTaggedUsers
                                  disabled={false}
                                  initialState={
                                    taggedUsers as ISelectedOption[]
                                  }
                                  callBackSelectedOptions={
                                    handleSelectedOptions
                                  }
                                />
                              </div>
                              {roomNumberOrOutlet[
                              template &&
                              template.category.find(
                                (cat) =>
                                  cat.categoryType === 'category' &&
                                  cat.uuid === selectedCategoryId
                              ).value
                                ] && (
                                <>
                                  <TextAreaLabel>
                                    {
                                      roomNumberOrOutlet[
                                      template &&
                                      template.category.find(
                                        (cat) =>
                                          cat.categoryType === 'category' &&
                                          cat.uuid === selectedCategoryId
                                      ).value
                                        ]
                                    }
                                  </TextAreaLabel>
                                  <ControlTextarea
                                    style={{
                                      height: '81px !important',
                                      overflow: 'hidden !important',
                                      outline: 'none !important',
                                      color: '#1F1F1F !important',
                                      border: '1px solid #D9D9D9 !important',
                                      borderRadius: '0.5rem !important',
                                      padding: '12px 16px !important',
                                      backgroundColor: '#FFFFFF !important',
                                      fontSize: '13px !important',
                                      fontFamily: 'Source Sans Pro !important',
                                      marginBottom: '16px',
                                    }}
                                    placeholder={isRoomType}
                                    minRows={3}
                                    value={
                                      isRoomType === 'Room Number/Name'
                                        ? selfAssessment.duplicateCategories[
                                        selectedIndex
                                        ].roomNumber || ''
                                        : isRoomType === 'Outlet Name'
                                          ? selfAssessment.duplicateCategories[
                                          selectedIndex
                                          ].outlet || ''
                                          : ''
                                    }
                                    onChange={(e) => {
                                      handleEqCommnetary(
                                        isRoomType === 'Room Number/Name'
                                          ? 'roomNumber'
                                          : 'outletName',
                                        escape(e.target.value)
                                      );
                                    }}
                                  />
                                </>
                              )}

                              <div style={{ marginTop: '36px' }}>
                                <ButtonBlockColumn>
                                  <ButtonLarge
                                    title={t(
                                      'COMMON.SELF_ASSESSMENT.BUTTON.SAVE_SELF_ASSESSMENT'
                                    )}
                                    onClick={() => handleSave()}
                                    backgroundColor="oxfordBlue"
                                    loading={isLoading}
                                  />
                                  <>
                                    <ButtonLarge
                                      title={t(
                                        'COMMON.SELF_ASSESSMENT.BUTTON.SUBMIT_SELF_ASSESSMENT'
                                      )}
                                      onClick={() => {
                                        if (checkForMissingTemplateEqId()) {
                                          setShowSubmitConfirmationModal(true);
                                        }
                                      }}
                                      backgroundColor="verdigris"
                                      textColor="oxfordBlue"
                                      disabled={isLoading || submitLoading}
                                    />
                                    <ButtonLarge
                                      onClick={() =>
                                        navigate(
                                          '/SelfAssessments/received/false/all'
                                        )
                                      }
                                      title="Back"
                                      outlined={true}
                                      inverted={true}
                                      loading={submitLoading}
                                      disabled={isLoading || submitLoading}
                                    />
                                  </>
                                </ButtonBlockColumn>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </SubTabContainer>
              </div>
            </div>

            {selectedUrl.length > 0 && (
              <OverlayAudio
                isOpen={audioOverlayOpened}
                setOpen={setAudioOverlayOpened}
                audioUrls={selectedUrl}
                setAudio={setSelectedUrl}
              />
            )}
          </Block>
        </ContentArea>
      )}
    </AssessmentStandarContainer>
  );
};

export default EditSelfAssessment;
